<template>
    <div>
        <simple-input
            :value="url"
            :placeholder="placeholder"
            @input="url = $event;"
            class="mb-16"
        >
            {{ $t('form.video') }}
            <span v-if="typeof language != 'undefined'">({{ language }})</span>
        </simple-input>

        <div class="w-full relative bg-primary text-white rounded overflow-hidden" style="padding: 56.25% 0 0 0;">
            <div class="absolute inset-0 w-full h-full p-32 flex items-center justify-center">
                <span>{{ $t('site_editor.video.preview') }}</span>
            </div>
            <iframe
                class="absolute inset-0 w-full h-full"
                v-if="validUrl"
                :src="embedUrl"
                allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                frameborder="0"
            ></iframe>
        </div>
    </div>
</template>

<script>
import Input from '../forms/Input.vue';
import { videoPlayer } from '../../mixins/videoPlayer';

export default {
    components: {
        'simple-input': Input,
    },
    mixins: [videoPlayer()],
    props: ['language', 'value'],
    computed: {
        embedUrl () {
            return this.embedVideo(this.url);
        },
        url: {
            get () {
                return this.value || '';
            },
            set (value) {
                this.$emit('update', value);
            }
        },
        validUrl () {
            return this.validateVideo(this.url);
        }
    }
}
</script>
